<template>
  <div class="rightconover">
    <div class="contentwidth">
      <div class="ContentMargin">
        <div>
          <div class="content_head">
            <div class="content_head_ico">
              <img src="@/assets/images/estorage/content_title_ico_blue.png" alt=""/>
            </div>
            <div class="content_head_title">
              质检项增扣重标准
            </div>
            <div class="content_head_button">
<!--              <div class="content_head_seek">-->
<!--                <lk-button img="add.png" @click="QCDetails('新增')">新增</lk-button>-->
<!--              </div>-->
              <div class="content_head_seek">
                <el-input placeholder="输入质检项" v-model="queryCheckNumber" class="input-with-select">
                  <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
                </el-input>
              </div>
            </div>
          </div>
          <div class="Notice_list">
            <el-table
                :data="standard"
                style="width: 100%"
            >
              <el-table-column
                  prop="QCName"
                  label="质检项"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="standardDetail"
                  label="增扣重标准明细"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="grainVariety"
                  label="粮食品种"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="standardName"
                  label="增扣重标准名称"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="standardNumber"
                  label="标准值%"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="state"
                  label="状态"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="description"
                  label="描述"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="addTime"
                  label="添加时间"
                  align="center">
              </el-table-column>
              <el-table-column
                  label="操作"
                  align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="QCDetails('详情',scope.row)">详情</el-button>
<!--                  <el-button type="text" size="small" @click="QCDetails('编辑',scope.row)">编辑</el-button>-->
<!--                  <el-button type="text" size="small" @click="QCDetails('删除',scope.row)" style="color: red">删除-->
<!--                  </el-button>-->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!--          分页器-->
          <div class="paging">
            <div class="block">
              <el-pagination
                  background
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  layout="total, prev, pager, next, jumper"
                  :total="totalQuantity">
              </el-pagination>
            </div>
          </div>
          <!--        新增，详细，编辑弹窗-->
          <el-dialog
              :title="dialogTitle"
              :visible.sync="redactShow"
              width="30%"
              style="margin-top: 20vh"
          >
            <div class="dialog_content" v-if="dialogTitle==='详情'||dialogTitle==='删除'">
              <p>质检项: {{ QCName }}</p>
              <p>粮食品种: {{ grainVariety }}</p>
              <!--              <p>增扣重标准明细: {{ standardDetail }}</p>-->
              <p>增扣重标准名称: {{ standardName }}</p>
              <p>标准值（%）: {{ standardNumber }}</p>
              <p>增扣重标准状态: {{ standardUpper }}</p>
              <p>备注: {{ description }}</p>
            </div>
            <div class="dialog_content" v-if="dialogTitle==='编辑'||dialogTitle==='新增'">
              <div class="dialog_content_c">
                <span><span style="color:red;padding-right:0;width:auto;">*</span>质检项:</span>
                <el-select v-model="QCName" placeholder="请选择">
                  <el-option
                      v-for="item in QCNameList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="dialog_content_c">
                <span><span style="color:red;padding-right:0;width:auto;">*</span>粮食品种:</span>
                <el-select v-model="grainVariety" placeholder="请选择">
                  <el-option
                      v-for="item in grainVarietyList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="dialog_content_c">
                <span>增扣重标准名称:</span>
                <el-input v-model="standardName" placeholder="增扣重标准名称"></el-input>
              </div>
              <div class="dialog_content_c">
                <span><span style="color:red;padding-right:0;width:auto;">*</span>标准值（%）:</span>
                <el-input v-model="standardNumber" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g,'$1')"
                          placeholder="标准值" @blur="standardNumber = $event.target.value"></el-input>
              </div>
              <div class="dialog_content_c">
                <span><span style="color:red;padding-right:0;width:auto;">*</span>增扣重标准状态:</span>
                <el-select v-model="state" placeholder="请选择">
                  <el-option
                      v-for="item in stateList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="dialog_content_c">
                <span>备注:</span>
                <el-input v-model="description" type="textarea" placeholder="描述"></el-input>
              </div>
            </div>
            <span slot="footer" class="dialog-footer" v-if="dialogTitle==='编辑'||dialogTitle==='新增'">
              <el-button @click="redactShow = false">取消</el-button>
              <el-button type="primary" @click="addQCDate">保存</el-button>
            </span>
            <span slot="footer" class="dialog-footer" v-if="dialogTitle==='删除'">
              <el-button @click="redactShow = false">取消</el-button>
              <el-button type="danger" @click="QCDelete">删除</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const type = require('@/utils/type.js')
import {httpToken} from '@/utils/http'
import qs from 'qs'

export default {
  name: 'Increase',
  data() {
    return {
      standard: [],
      ids: '',
      QCName: '',
      grainVariety: '',
      standardName: '',
      standardNumber: '',
      state: '',
      description: '',
      QCNameList: [
        {value: '水分%'},
        {value: '杂质%'},
        {value: '矿物质%'},
        {value: '不完善粒%'},
        {value: '生霉粒%'},
        {value: '容重g/L'},
        {value: '出糙率%'}
      ],
      grainVarietyList: [
        {value: '小麦'},
        {value: '玉米'},
        {value: '晚籼稻'},
        {value: '菜籽油'}
      ],
      stateList: [
        {value: '在用'},
        {value: '未用'}
      ],
      standardALL: [],
      currentPage: 1,
      totalQuantity: 10,
      queryCheckNumber: '',
      redactShow: false,
      dialogTitle: '',
      current: 1
    }
  },
  methods: {
    //上传新增或更改质检项数据
    addQCDate() {
      const _this = this
      if (this.QCName === '') {
        this.$message({
          message: '请选择质检项',
          type: 'error'
        })
      } else if (this.grainVariety === '') {
        this.$message({
          message: '请选择粮食品种',
          type: 'error'
        })
      } else if (this.standardNumber === '') {
        this.$message({
          message: '请填写标准值（%）',
          type: 'error'
        })
      } else if (this.state === '') {
        this.$message({
          message: '请选择增扣重标准状态',
          type: 'error'
        })
      } else {
        if (this.ids) {
          httpToken({
            url: '/qualityManage/updateAddSubStandard',
            method: 'post',
            data: {
              id: this.ids,
              checkCodeCn: this.QCName,
              grKind: this.grainVariety,
              addSubStanName: this.standardName,
              standardVal: this.standardNumber,
              statusCn: this.state,
              adSuDescribe: this.description
            }
          }).then(res => {
            this.redactShow = false
            // console.log(res)
            if (res.data.code === 200) {
              this.$message({
                message: res.data.msg,
                type: 'success'
              })
              _this.getQCList(this.current)
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
        } else {
          httpToken({
            url: '/qualityManage/saveAddSubStandard',
            method: 'post',
            data: {
              checkCodeCn: this.QCName,
              grKind: this.grainVariety,
              addSubStanName: this.standardName,
              standardVal: this.standardNumber,
              statusCn: this.state,
              adSuDescribe: this.description
            }
          }).then(res => {
            this.redactShow = false
            // console.log(res)
            if (res.data.code === 200) {
              this.$message({
                message: res.data.msg,
                type: 'success'
              })
              _this.getQCList(this.current, 1)
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
        }
      }
    },
    // 获取质检项数据
    getQCList(page, max) {
      let paramData = [
        {
          column: "id",
          type: '',
          value: ''
        }
      ]
      if (this.queryCheckNumber) {
        paramData.push(
            {
              column: "check_code_cn",
              type: type.default.like,
              value: this.queryCheckNumber
            }
        )
      }
      httpToken({
        url: '/subStandard/list',
        method: 'post',
        data: qs.stringify({
          paramData: JSON.stringify(paramData),
          page: page,
          rows: 10
        })
      }).then(res => {
        if (max === 1) {
          if (res.data.data.current !== page || res.data.data.current !== res.data.data.pages) {
            this.getQCList(res.data.data.pages)
            return;
          }
        } else if (max === 2) {
          if (res.data.data.current !== page) {
            this.getQCList(res.data.data.pages)
            return;
          }
        }
        // console.log(res.data.data)
        const QCALL = res.data.data
        this.standard = []
        for (let q = 0; q < QCALL.records.length; q++) {
          const QC = QCALL.records[q]
          this.standard.push(
              {
                ids: QC.id,
                QCName: QC.checkCodeCn,
                // standardDetail: QC.chItemCn,
                grainVariety: QC.grKind,
                standardName: QC.addSubStanName,
                standardNumber: QC.standardVal,
                state: QC.statusCn,
                description: QC.adSuDescribe,
                addTime: QC.createDate.replace('T', ' '),
              }
          )
        }
        this.totalQuantity = QCALL.total
        this.currentPage = page
        this.current = page
      })
    },
    // 详情和编辑和新增按键
    QCDetails(val, state) {
      this.redactShow = true
      this.dialogTitle = val
      if (state) {
        this.ids = state.ids
        this.QCName = state.QCName
        this.grainVariety = state.grainVariety
        this.standardName = state.standardName
        this.standardNumber = state.standardNumber
        this.state = state.state
        this.description = state.description
      } else {
        this.ids = ''
        this.QCName = ''
        this.grainVariety = ''
        this.standardName = ''
        this.standardNumber = ''
        this.state = ''
        this.description = ''
      }
    },
    // 删除质检项信息
    QCDelete() {
      httpToken({
        url: '/qualityManage/deleteAddSubStandard?id=' + this.ids,
        method: 'post'
      }).then(res => {
        if (res.data.code === 200) {
          this.redactShow = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getQCList(this.current, 2)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
      })
    },
    // 切换页码
    handleCurrentChange(val) {
      this.getQCList(val)
    }
  },
  mounted() {
    this.getQCList(1)
  }
}
</script>

<style scoped lang="scss">
.rightconover {
  height: 100%;
  background-color: #f5f6fa;
  overflow: auto;

  .contentwidth {
    width: 100%;

    .ContentMargin {
      box-sizing: border-box;
      margin: 30px 35px;
      background-color: #ffffff;
      box-shadow: 0 3px 5px 0 #d5dade;
      padding: 30px 40px;
    }
  }
}

.content_head {
  display: flex;
  font-size: 18px;
  margin-bottom: 50px;

  .content_head_ico {
    height: 17px;
    width: 4px;
    margin: auto 10px auto 0;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .content_head_title {
    margin: auto 0;
  }

  .content_head_button {
    max-width: 70%;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    margin-left: auto;

    ::v-deep .el-button {
      padding: 10px 42px;
      font-size: 16px;

      span {
        font-size: 14px;
      }
    }

    .content_head_seek {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;
      margin-bottom: 20px;

      ::v-deep .el-input-group__append {
        padding: 0 18px;
      }

      .el-button {
        padding: 10px;
      }
    }
  }
}

.Notice_list {
  ::v-deep .el-table th {
    background-color: #F5F8FF;
  }

  ::v-deep .el-table thead {
    color: #000000
  }
}

.dialog_content {
  //margin-bottom: 30px;

  p {
    margin-bottom: 10px;
  }

  .dialog_content_c {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    span {
      text-align: right;
      width: 30%;
      padding-right: 10px;
    }

    .el-select {
      width: 60%;
      margin: auto 0;
    }

    .el-input {
      width: 60%;
      margin: auto 0;
    }

    .el-textarea {
      width: 60%;
      margin: auto 0;
    }
  }
}

.paging {
  margin-top: 20px;

  ::v-deep .el-pagination {
    text-align: right;
  }
}
</style>
